// extracted by mini-css-extract-plugin
export default {"container":"status-toggle-label_container__6aPEn","truncate-table":"status-toggle-label_truncate-table__vMMA3","table-text-faded":"status-toggle-label_table-text-faded__h5Kim","label":"status-toggle-label_label__UfOsJ","active":"status-toggle-label_active__Q5V0w","inactive":"status-toggle-label_inactive__oUWSI"};
    if(module.hot) {
      // 1792500641955
      var cssReload = require("!../../../../node_modules/.pnpm/css-hot-loader@1.4.4/node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  